module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAMCAYAAACulacQAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAC0SURBVBiVbc+9CcJgEIDh92IU/BkgIziAC3yVIWkVHME24AqWoqWuIIKFfCHR4hYQxAks3SGFZxUw6rXPwb1HXuojL3XCnwlMmAJrX+j8GwXgVOqwBReMVRK7TQMBvNcoCFGDIhm7rIH1grQ5Atdum6yBAHvVQb+iEHgG/yrFMANpoPcaDSouBvdeh9lvkOGT2C0AgvoVCbmZsasBQPxZR2IczVimsdt+ngl5cUDI0tgdvsPesxVCDp4PrkUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/run.png
// module id = fWiM
// module chunks = 1